import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['DownloadReport'],
});

export const downloadReportApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findOnInitDownloadReport: builder.query({
      query: () => `download-report/init/`,
      providesTags: ['DownloadReport'],
    }),

    findAllDownloadReportByPagination: builder.query({
      query: (payload) => {
        let url = `download-report/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      // providesTags: ['DnList'],
    }),

    confirmDownloadReport: builder.mutation({
      query: (payload) => ({
        url: `download-report/confirm/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['DownloadReport'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const { useConfirmDownloadReportMutation } = downloadReportApi;
